import React from 'react';

import { AppFooter, CardAuth } from '../../components';

import type { SingleCardProps } from '../../types';

import './single-card.scss';

export const SingleCard = ({ title, description, children }: React.PropsWithChildren<SingleCardProps>) => {
  return (
    <div className="login-page">
      <CardAuth title={title} description={description}>
        {children}
      </CardAuth>
      <AppFooter />
    </div>
  );
};
